import { render, staticRenderFns } from "./registerStandardModal.vue?vue&type=template&id=edd9f490&scoped=true&lang=html&"
import script from "./registerStandardModal.vue?vue&type=script&lang=js&"
export * from "./registerStandardModal.vue?vue&type=script&lang=js&"
import style0 from "./registerStandardModal.vue?vue&type=style&index=0&id=edd9f490&lang=scss&scoped=true&"
import style1 from "./registerStandardModal.vue?vue&type=style&index=1&lang=css&"
import style2 from "./registerStandardModal.vue?vue&type=style&index=2&lang=scss&media=screen&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd9f490",
  null
  
)

export default component.exports